import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import * as ConversationActions from './conversations';
import { forbiddenAccess } from './auth';
import utils from '../lib/utils';

const request = superagent
  .agent()
  .set('ETag', window.Config.APP_VERSION)
  .use(function (req) {
    req.on('response', function (res) {
      if (res.status === 401) {
        console.log('UnAuthorized');
        return {
          type: types.LOGOUT_USER,
        };
      } else if (res.status === 403) {
        console.log('Forbidden');
        forbiddenAccess();
      }
    });
  });
export function getBookingSoftwareStart() {
  return {
    type: types.GET_SOFTWARES_START,
  };
}

export function getBookingSoftwareSuccess({ info }) {
  return {
    type: types.GET_SOFTWARES_SUCCESS,
    info,
  };
}

export function getBookingSoftwareFail() {
  return {
    type: types.GET_SOFTWARES_FAIL,
  };
}

export function resetSelectedSoftware() {
  return {
    type: types.RESET_SELECTED_SOFTWARE,
  };
}

export function setBookingSoftwareReset() {
  return {
    type: types.SET_SOFTWARES_RESET,
  };
}

export function setBookingSoftwareSuccess({
  software,
  activationCode,
  activationLink,
}) {
  return {
    type: types.SET_SOFTWARES_SUCCESS,
    software,
    activationCode,
    activationLink,
  };
}

export function setBookingSoftwareFail() {
  return {
    type: types.SET_SOFTWARES_FAIL,
  };
}

export function selectSoftware({ software, isIntegrated }) {
  return {
    type: types.BOOKING_SOFTWARE_SELECTED,
    software,
    isIntegrated,
  };
}

export function resetSoftwareSelection() {
  return {
    type: types.RESET_BOOKING_SOFTWARE_SELECTED,
  };
}

export function getStudioIdSuccess({ studioId }) {
  return {
    type: types.GET_STUDIO_ID_SUCCESS,
    studioId,
  };
}

export function getStudioIdFail() {
  return {
    type: types.GET_STUDIO_ID_FAIL,
  };
}

export function getBookingSoftwareActivationStart() {
  return {
    type: types.GET_SOFTWARE_ACTIVATION_START,
  };
}

export function getBookingSoftwareActivationSuccess() {
  return {
    type: types.GET_SOFTWARE_ACTIVATION_SUCCESS,
  };
}

export function getBookingSoftwareActivationFail() {
  return {
    type: types.GET_SOFTWARE_ACTIVATION_FAIL,
  };
}

export function completetBookingSoftwareSetup() {
  return {
    type: types.COMPLETE_BOOKING_SOFTWARE_SETUP,
  };
}

export function resetBookingSoftwareSetup() {
  return {
    type: types.RESET_BOOKING_SOFTWARE_SETUP,
  };
}

export function getBookingSoftware() {
  return (dispatch) => {
    dispatch(getBookingSoftwareStart());
    return request
      .get(`${window.Config.API_URL}/business/bookingSW`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        dispatch(getBookingSoftwareSuccess({ info: resp.body }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getBookingSoftwareFail());
      });
  };
}

export function setBookingSoftware(authDetails) {
  return (dispatch, getState) => {
    dispatch(setBookingSoftwareReset());

    const { auth, softwares } = getState();
    const bookingSoftware = Object.assign({}, authDetails, {
      id: auth.userid,
      type: softwares.selectedSoftware,
    });

    return request
      .post(`${window.Config.API_URL}/business/bookingSW`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(bookingSoftware)
      .then((resp) => {
        const responseData = {
          software: bookingSoftware,
        };

        if (resp.body && resp.body.code && resp.body.link) {
          responseData.activationCode = resp.body.code;
          responseData.activationLink = resp.body.link;
        }

        dispatch(setBookingSoftwareSuccess(responseData));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(setBookingSoftwareFail());
      });
  };
}

export function getMBStudioId() {
  return (dispatch) => {
    return request
      .get(`${window.Config.API_URL}/business/studioId`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getStudioIdSuccess({ studioId: resp.body.data.id }));
          // dispatch(
          //   ConversationActions.getConversationSummary(resp.body.data.id),
          // );
          const businessStatus = utils.getCookie('subscription_status');
          if (businessStatus === 'LIVE') {
            dispatch(ConversationActions.getOptOutnumbers(resp.body.data.id));
          }
          dispatch(ConversationActions.getBlockUser(resp.body.data.id));
        } else {
          dispatch(getStudioIdFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
  };
}

export function getBookingSoftwareActivation() {
  return (dispatch) => {
    dispatch(getBookingSoftwareActivationStart());

    request
      .get(`${window.Config.API_URL}/business/active`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getBookingSoftwareActivationSuccess());
        } else {
          dispatch(getBookingSoftwareActivationFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getBookingSoftwareActivationFail());
      });
  };
}

export function verifyBookingSoftwareStart() {
  return {
    type: types.VERIFY_BOOKING_SOFTWARE_START,
  };
}

export function verifyBookingSoftwareSuccess() {
  return {
    type: types.VERIFY_BOOKING_SOFTWARE_SUCCESS,
  };
}

export function verifyBookingSoftwareFail() {
  return {
    type: types.VERIFY_BOOKING_SOFTWARE_FAIL,
  };
}

export function postBookingSoftwareVerification() {
  return (dispatch, getState) => {
    dispatch(verifyBookingSoftwareStart());

    const { auth } = getState();
    const params = Object.assign(
      {},
      {
        id: auth.userid,
      },
    );

    request
      .post(`${window.Config.API_URL}/business/bookingSW/verified`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(verifyBookingSoftwareSuccess());
        } else {
          dispatch(verifyBookingSoftwareFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to set booking software verification status', ex);
        dispatch(verifyBookingSoftwareFail());
      });
  };
}

export function requestBookingSoftwareStart() {
  return {
    type: types.REQUEST_BOOKING_SOFTWARE_START,
  };
}

export function requestBookingSoftwareSuccess({ message }) {
  return {
    type: types.REQUEST_BOOKING_SOFTWARE_SUCCESS,
    message,
  };
}

export function clearBookingSoftwareFlg() {
  return {
    type: types.AUTH_FLAG_CLEAR,
  };
}
export function requestBookingSoftwareFail() {
  return {
    type: types.REQUEST_BOOKING_SOFTWARE_FAIL,
  };
}

export function postBookingSoftwareRequest(data) {
  return (dispatch, getState) => {
    dispatch(requestBookingSoftwareStart());

    const { auth, softwares } = getState();
    const params = Object.assign(
      {},
      {
        id: auth.userid,
        bookingSW: softwares.selectedSoftware,
        login: data.username,
        password: data.password,
        studio_name: data.studio_name,
        studio_address: data.studio_address,
        site_link: data.site_link,
        timezone: data.timezone,
        organization: data.organization,
        accountName: data.accountName,
      },
    );

    if (Object.prototype.hasOwnProperty.call(data, 'booking_sw')) {
      params.bookingSW = data.booking_sw;
    }

    request
      .post(`${window.Config.API_URL}/business/request/approval`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(
            requestBookingSoftwareSuccess({ message: resp.body.message }),
          );
        } else {
          dispatch(requestBookingSoftwareFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to set booking software request status', ex);
        dispatch(requestBookingSoftwareFail());
      });
  };
}

export function getBookingSoftwareRequestStart() {
  return {
    type: types.GET_BOOKING_SOFTWARE_REQUEST_START,
  };
}

export function getBookingSoftwareRequestSuccess({ software }) {
  return {
    type: types.GET_BOOKING_SOFTWARE_REQUEST_SUCCESS,
    software,
  };
}

export function getBookingSoftwareRequestFail() {
  return {
    type: types.GET_BOOKING_SOFTWARE_REQUEST_FAIL,
  };
}

export function getBookingSoftwareRequest({ requestId }) {
  return (dispatch) => {
    dispatch(getBookingSoftwareRequestStart());

    // const { auth, softwares } = getState();
    const params = {
      query: requestId,
    };

    request
      .get(`${window.Config.API_URL}/configure/request/approval`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .query(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getBookingSoftwareRequestSuccess({ software: resp.body }));
        } else {
          dispatch(getBookingSoftwareRequestFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to fetch booking software request status', ex);

        dispatch(getBookingSoftwareRequestFail());
      });
  };
}

export function bookingSoftwareRequestApproveStart() {
  return {
    type: types.APPROVE_BOOKING_SOFTWARE_ACCESS_START,
  };
}

export function bookingSoftwareRequestApproveSuccess() {
  return {
    type: types.APPROVE_BOOKING_SOFTWARE_ACCESS_SUCCESS,
  };
}

export function bookingSoftwareRequestApproveFail() {
  return {
    type: types.APPROVE_BOOKING_SOFTWARE_ACCESS_FAIL,
  };
}

export function postBookingSoftwareRequestApproved({
  userId,
  requestId,
  notes,
}) {
  return (dispatch) => {
    dispatch(bookingSoftwareRequestApproveStart());

    const params = Object.assign(
      {},
      {
        id: userId,
        reqId: requestId,
        notes,
      },
    );

    request
      .post(`${window.Config.API_URL}/configure/request/approved`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(bookingSoftwareRequestApproveSuccess());
        } else {
          dispatch(bookingSoftwareRequestApproveFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to set booking software request approval', ex);
        dispatch(bookingSoftwareRequestApproveFail());
      });
  };
}

export function bookingSoftwareRequestDeclineStart() {
  return {
    type: types.DECLINE_BOOKING_SOFTWARE_ACCESS_START,
  };
}

export function bookingSoftwareRequestDeclineSuccess() {
  return {
    type: types.DECLINE_BOOKING_SOFTWARE_ACCESS_SUCCESS,
  };
}

export function bookingSoftwareRequestDeclineFail() {
  return {
    type: types.DECLINE_BOOKING_SOFTWARE_ACCESS_FAIL,
  };
}

export function postBookingSoftwareRequestDecline({
  userId,
  requestId,
  notes,
}) {
  return (dispatch) => {
    dispatch(bookingSoftwareRequestDeclineStart());

    const params = Object.assign(
      {},
      {
        id: userId,
        reqId: requestId,
        notes,
      },
    );

    request
      .post(`${window.Config.API_URL}/business/request/declined`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(bookingSoftwareRequestDeclineSuccess());
        } else {
          dispatch(bookingSoftwareRequestDeclineFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to set booking software request approval', ex);
        dispatch(bookingSoftwareRequestDeclineFail());
      });
  };
}

const postBookerAccountInfoStart = () => {
  return {
    type: types.POST_BOOKER_ACCOUNT_INFO_START,
  };
};

const postBookerAccountInfoSuccess = (data) => {
  return {
    type: types.POST_BOOKER_ACCOUNT_INFO_SUCCESS,
    data,
  };
};

const postBookerAccountInfoFail = () => {
  return {
    type: types.POST_BOOKER_ACCOUNT_INFO_FAIL,
  };
};

export function postBookerAccountInfo(data) {
  return (dispatch, getState) => {
    dispatch(postBookerAccountInfoStart());

    const { auth } = getState();
    const params = Object.assign(
      {},
      {
        id: auth.userid,
        client_id: auth.userid,
        primary_account_email: data.email,
        primary_account_name: data.name,
        account_name: data.businessAccount,
        address: data.address,
        location_id: data.locationID,
      },
    );

    request
      .post(`${window.Config.API_URL}/business/bookingSW/booker/info`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(postBookerAccountInfoSuccess(data));
        } else {
          dispatch(postBookerAccountInfoFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to save booker account info', ex);
        dispatch(postBookerAccountInfoFail());
      });
  };
}

export function postBoulevardAuthorize(business_id) {
  return (dispatch, getState) => {
    const { auth } = getState();
    const params = Object.assign(
      {},
      {
        vendor: 'BOULEVARD',
        id: auth.userid,
        business_id,
      },
    );
    dispatch(requestBookingSoftwareStart());
    request
      .post(`${window.Config.API_URL}/business/bookingSW/authorize`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(
            requestBookingSoftwareSuccess({ message: resp.body.message }),
          );
        } else {
          dispatch(requestBookingSoftwareFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to save booker account info', ex);
        dispatch(requestBookingSoftwareFail());
      });
  };
}

export const onBookerEmailSent = () => {
  return (dispatch) => {
    dispatch({
      type: types.BOOKER_EMAIL_SEND_SUCCESS,
    });
  };
};

export const onBookerEmailSendReset = () => {
  return (dispatch) => {
    dispatch({
      type: types.BOOKER_EMAIL_SEND_RESET,
    });
  };
};

export const onZenotiAccountInfoStart = () => {
  return (dispatch) => {
    dispatch({
      type: types.POST_ZENOTI_ACCOUNT_INFO_START,
    });
  };
};

export const onZenotiAccountInfoSuccess = () => {
  return (dispatch) => {
    dispatch({
      type: types.POST_ZENOTI_ACCOUNT_INFO_SUCCESS,
    });
  };
};

export const onZenotiAccountInfoFail = (errorBody) => {
  return (dispatch) => {
    dispatch({
      type: types.POST_ZENOTI_ACCOUNT_INFO_FAIL,
      isAuthError: true,
      errorBody,
    });
  };
};

export function postZenotiAccountInfo(data) {
  return (dispatch, getState) => {
    dispatch(onZenotiAccountInfoStart());
    const { auth } = getState();
    const params = Object.assign(
      {},
      {
        id: auth.userid,
        vendor: data.client,
        account_name: data.account,
        api_key: data.apiKey,
        GTID: data.GTID,
        GMID: data.GMID,
        ...(data.sub_domain && { sub_domain: data.sub_domain }),
      },
    );

    if (data.client === 'ACUITY') {
      params['acuity_user_id'] = params['account_name'];
      delete params.account_name;
    } else if (data.client === 'RESTORE') {
      params['restore_site_id'] = params['account_name'];
      delete params.account_name;
    } else if (data.client === 'PHOREST') {
      params['business_id'] = data.BusinessID;
      delete params.account_name;
      delete params.api_key;
    } else if (data.client === 'MYTIME') {
      params['company_Id'] = data.account;
      delete params.account_name;
    } else if (data.client === 'MEEVO') {
      params['tenant_id'] = data.tenant_id;
    } else if (data.client === 'NEXHEALTH') {
      params['subdomain_id'] = data.subDomainId;
    } else if (data.client === 'CLOUD9') {
      params['client_id'] = data.clientId;
      params['user_name'] = data.userName;
      params['password'] = data.password;
    } else if (data.client === 'OPEN_DENTAL') {
      params['customer_api_key'] = data.APIKey;
      params['zone_id'] = data.zone_id;
    } else if (data.client === 'DENTICON') {
      params['client_id'] = data.client_id;
      params['client_secret'] = data.client_secret;
    } else if (data.client === 'DENTRIX_ASCEND') {
      params['organization_id'] = data.organizationId;
    }
    console.log(params);
    request
      .post(`${window.Config.API_URL}/business/bookingSW/form`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .ok((resp) => resp.status < 501)
      .then((resp) => {
        console.log('Unable to save booker account info', resp);
        if (resp.statusCode == 400) {
          console.log('DATAxyz', resp.body);
          const errorBody = resp?.body || {};
          dispatch(onZenotiAccountInfoFail(errorBody));
        } else if (resp.statusCode === 200) {
          console.log('Form', new Date());
          dispatch(onZenotiAccountInfoSuccess(data));
          if (data.client === 'PHOREST') {
            let staffData = {
              username: data.Login,
              password: data.Password,
            };
            dispatch(postStaffLogin(staffData));
          }
        } else {
          dispatch(onZenotiAccountInfoFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to save booker account info', ex);
        dispatch(onZenotiAccountInfoFail());
      });
  };
}

export function postBoulevardccountInfo(data) {
  return (dispatch, getState) => {
    dispatch(postBookerAccountInfoStart());

    const { auth } = getState();
    const params = Object.assign(
      {},
      {
        id: auth.userid,
        client_id: auth.userid,
        vendor: 'BOULEVARD',
        primary_account_email: data.email,
        primary_account_name: data.name,
        business_name: data.businessAccount,
        address: data.address,
        business_id: data.locationID,
      },
    );

    request
      .post(`${window.Config.API_URL}/business/bookingSW/form`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(postBookerAccountInfoSuccess(data));
        } else {
          dispatch(postBookerAccountInfoFail());
        }
      })
      .catch((ex) => {
        console.log('Unable to save booker account info', ex);
        dispatch(postBookerAccountInfoFail());
      });
  };
}

export function postZenotiAuthorize(data) {
  return (dispatch, getState) => {
    // dispatch(requestBookingSoftwareStart());
    // setTimeout(() => {
    //   dispatch(requestBookingSoftwareSuccess(data));
    // }, 100);

    const { auth } = getState();
    const params = Object.assign(
      {},
      {
        id: auth.userid,
        ...(data?.location_id && { location_id: data.location_id }),
        ...(data?.referral_email && { referral_email: data.referral_email }),
      },
    );
    dispatch({ type: types.POST_ZENOTI_AUTHORIZATION_START });
    request
      .post(`${window.Config.API_URL}/business/bookingSW/authorize`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .send(params)
      .then((resp) => {
        console.log('save booker account info', resp);
        if (resp.statusCode === 200) {
          dispatch({ type: types.POST_ZENOTI_AUTHORIZATION_SUCCESS });
        } else {
          dispatch({ type: types.POST_ZENOTI_AUTHORIZATION_FAIL });
        }
      })
      .catch((ex) => {
        console.log('Unable to save booker account info', ex);
        dispatch({ type: types.POST_ZENOTI_AUTHORIZATION_FAIL });
      });
    // dispatch({ type: types.POST_ZENOTI_AUTHORIZATION_SUCCESS });
  };
}

export function postStaffLogin(data) {
  return (dispatch, getState) => {
    // dispatch(requestBookingSoftwareStart());
    dispatch({ type: types.POST_ZENOTI_STAFF_LOGIN_START });
    if (data && data.skip && data.skip === true) {
      dispatch({ type: types.POST_ZENOTI_STAFF_LOGIN_SUCCESS });
    } else {
      const { auth } = getState();
      const params = Object.assign(
        {},
        {
          id: auth.userid,
          login: data.username,
          password: data.password,
        },
      );

      request
        .post(`${window.Config.API_URL}/business/bookingSW/staff`)
        .withCredentials()
        .set('X-Request-ID', uuidv4())
        .send(params)
        .then((resp) => {
          console.log('set booking software request status', resp);
          if (resp.statusCode === 200) {
            console.log('Staff', new Date());
            // dispatch(requestBookingSoftwareSuccess({ message: resp.body.message }));
            dispatch({ type: types.POST_ZENOTI_STAFF_LOGIN_SUCCESS });
          } else {
            // dispatch(requestBookingSoftwareFail());
            dispatch({ type: types.POST_ZENOTI_STAFF_LOGIN_FAIL });
          }
        });
    }
  };
}

export const getBookingSoftwareLocationsStart = () => {
  return (dispatch) => {
    dispatch({
      type: types.GET_BOOKING_SOFTWARE_LOCATIONS_START,
    });
  };
};
export const getBookingSoftwareLocationsSuccess = (locations) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_BOOKING_SOFTWARE_LOCATIONS_SUCCESS,
      locations,
    });
  };
};
export const getBookingSoftwareLocationsFail = () => {
  return (dispatch) => {
    dispatch({
      type: types.GET_BOOKING_SOFTWARE_LOCATIONS_FAIL,
    });
  };
};
export function getBookingSoftwareLocations() {
  return (dispatch) => {
    dispatch(getBookingSoftwareLocationsStart());
    console.log('locations', new Date());
    return request
      .get(`${window.Config.API_URL}/business/bookingSW/locations`)
      .withCredentials()
      .set('X-Request-ID', uuidv4())
      .then((resp) => {
        if (resp.statusCode === 200) {
          dispatch(getBookingSoftwareLocationsSuccess(resp.body));
        } else {
          dispatch(getBookingSoftwareLocationsFail());
        }
      })
      .catch((ex) => {
        dispatch(getBookingSoftwareLocationsFail());
      });
  };
}

export const onZenotiConfigureSetup = () => {
  return (dispatch) => {
    dispatch({
      type: types.POST_ZENOTI_CONFIGURE_SETUP,
    });
  };
};

export const onZenotiReferral = () => {
  return (dispatch) => {
    dispatch({
      type: types.POST_ZENOTI_REFERRAL,
    });
  };
};
export const storeZentiData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.STORE_ZENOTI_DATA,
      data,
    });
  };
};

export const storeMeevoData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.STORE_MEEVO_DATA,
      data,
    });
  };
};
